import {
	CanActivateChildFn,
	CanActivateFn,
} from '@angular/router';
import { requireUserPermission } from './admin-global.guard';

export const AdminAccessGuard: CanActivateFn | CanActivateChildFn = async (
	route,
	state
) => requireUserPermission(['admin:global', 'admin:global:crm']);

